module.exports = __webpack_public_path__ + "static/media/sliderImage2.e36b3ccd.png";